import * as React from 'react';

import ApiKeyContext from "../../../../contexts/ApiKeyContext.js";
import SaleReport from "./SaleReport.js";

import './SaleReportConversationHeader.scss';

export default function SaleReportConversationHeader({ saleReportId }) {
	const API_KEY_CONTEXT = React.useContext(ApiKeyContext);
	const [saleReport, setSaleReport] = React.useState(false);

	const getSaleReport = React.useCallback(async () => {
		const sale_report = await SaleReport.Load(API_KEY_CONTEXT, saleReportId);
		setSaleReport(sale_report);
	}, []);
	React.useEffect(() => {
		getSaleReport();
	}, []);

	if (!saleReport?.id) {
		return (<div className="sale-report-conversation-header"></div>);
	}
	return (
		<div className="sale-report-conversation-header">
			Sale Report #{saleReport.id}
			{saleReport.customer}
			<div className="sale-date">Sold on {new Date(saleReport.sale_date).toLocaleString().split(',')[0]}</div>
		</div>
	);
}